import {Block} from 'blocks/block'
import {Image} from 'layout/partials/image'
import {Theme} from 'layout/theme'
import React from 'react'
import {WysiwygType} from 'types/basictypes'
import {DPListBlock} from 'types/DPTypes'
import {fromModule} from 'util/styler/Styler'
import {useIDFromAnchorBlock} from 'util/useAnchor'
import css from './list.module.scss'

const styles = fromModule(css)

export const List: React.FC<DPListBlock> = (data) => {
	const {_type, title, items, image, display_single} = data
	const id = useIDFromAnchorBlock(data)
	if (!items || items.length === 0) return null
	const hasimage = image ? true : false

	return (
		<Block type={_type} className={styles.list()} anchorID={id}>
			<Theme.Container>
				{title && (
					<Theme.H2 className={styles.list.title()} mod="blueline">
						{title}
					</Theme.H2>
				)}
				{!hasimage && (
					<ListItems items={items} display_single={display_single} />
				)}
				{hasimage && (
					<div className={styles.list.row()}>
						<div className={styles.list.row.col()}>
							<ListItems items={items} hasimage={hasimage} />
						</div>
						<div className={styles.list.row.col()}>
							<Image {...image} sizes="(max-width: 600px) 100vw, 640px" />
						</div>
					</div>
				)}
			</Theme.Container>
		</Block>
	)
}

const ListItems: React.FC<{
	items: Array<WysiwygType>
	display_single?: boolean
	hasimage?: boolean
}> = ({items, display_single, hasimage}) => {
	if (!items || items.length === 0) return null

	return (
		<div
			className={styles.items
				.mod({fullwidth: display_single})
				.mod({hasimage})()}
		>
			{items.map((item, i) => (
				<div key={i} className={styles.items.item()}>
					<div className={styles.items.item.content()}>
						<span className={styles.items.item.content.checkmark()} />
						<span className={styles.items.item.content.text()}>
							<Theme.TrustedText>{item}</Theme.TrustedText>
						</span>
					</div>
				</div>
			))}
		</div>
	)
}
